import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Spin, Switch, Select, Tooltip, Icon } from 'antd';
import Chart from '../../components/Chart';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import ExportUtil from '../../../../common/ExportUtil';
import { ProjectDimension } from '../../constants/common';
import format from '../../../shared/format';
import moment from 'moment';
import { DefaultParams } from '../../constants/project';

const { Option } = Select;

class PieChartBox extends PureComponent {
    static contextTypes = {
        handleExpand: PropTypes.func
    }

    constructor(props) {
        super(props);
        const { projectDimension } = props;
        const searchParams = {};
        if (projectDimension) {
            searchParams.projectDimension = projectDimension[0];
        }
        this.state = {
            data: {},
            loading: false,
            showLegend: false,
            searchParams,
        };
    }

    componentDidMount() {
        if (this.props.params.statisticDate) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refresh !== this.props.refresh) {
            this.loadData();
        }
    }

    loadData = () => {
        const { activeKey } = this.context;
        const { moduleType, params } = this.props;
        const { searchParams } = this.state;
        const { investigationMedicineType = [] } = params;
        this.setState({ loading: true });
        Fetch.post(API_URL.dashboard.queryStatisticReportData, {
            moduleType,
            ...params,
            ...searchParams,
            date: params.statisticDate?moment(params.statisticDate).format("YYYY"):null,
            year:params.statisticDate?moment(params.statisticDate).format("YYYY"):null,
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
            //...DefaultParams[activeKey]
        }).then(res => {
            this.setState({
                data: res,
                loading: false
            });
        });
    }

    handleExport = () => {
        const { moduleType, params } = this.props;
        const { searchParams } = this.state;
        ExportUtil.export({
            moduleType,
            ...params,
            ...searchParams,
            date: params.statisticDate?moment(params.statisticDate).format("YYYY"):null,
            year:params.statisticDate?moment(params.statisticDate).format("YYYY"):null,
        }, null, API_URL.dashboard.exportStatisticReportData)
    }

    handleChange = (checked) => {
        this.setState({ showLegend: checked });
    }

    handleSelect = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams }, () => {
            this.loadData();
        });
    }

    render() {
        const { handleExpand } = this.context;
        const { title, tips, chartTypes, toType, projectDimension,params } = this.props;
        const { loading, showLegend, data, searchParams } = this.state;
        const { monthList = [] } = data;
        const categories = monthList.map(i => format('month', i.year, i.month))||[];
        const series = [];
        chartTypes.forEach(type => {
            const obj = data.data || {};
            series.push({
                type: 'pie',
                data: Object.entries(obj).map(([key, value]) => ({
                    name: key,
                    y: value
                }))
            });
        });
        const ProjectDimensionOption = Object.keys(ProjectDimension)
            .filter(i => (projectDimension || []).includes(i))
            .map(i => <Option key={i}>{ProjectDimension[i]}</Option>);
        return (
            <div className="flexItem outer">
                <Spin spinning={loading}>
                    <div className="chartHeader">
                        <div className="modTitle">
                            <span>{title}</span>
                            {
                                tips &&
                                <Tooltip overlayStyle={{ width: 210, wordBreak: 'break-all' }} placement="top" title={tips}>
                                    <Icon style={{ marginLeft: 6, fontSize: '14px', cursor: 'pointer' }} type="info-circle-o" />
                                </Tooltip>
                            }
                            <div className="legendContainer" style={{ display: 'inline-block', fontWeight: 'normal', color: '#999',marginLeft:"5px" }}>
                                <Switch size="small" checked={showLegend} onChange={this.handleChange} 
                                 style={{marginBottom:"2px"}}/>
                                <span className="text">{!showLegend?"图例隐藏":"图例显示"}</span>
                            </div>
                        </div>
                        <div className="chartFilter filter-wrap">
                            {
                                projectDimension &&
                                <div className="filter-item">
                                    <label htmlFor="" className="filter-label">占比统计维度</label>
                                    <Select
                                        allowClear={false}
                                        value={searchParams.projectDimension}
                                        placeholder="请选择"
                                        style={{ width: 120 }}
                                        onChange={value => this.handleSelect(value, 'projectDimension')}
                                    >
                                        {ProjectDimensionOption}
                                    </Select>
                                </div>
                            }
                        </div>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <Chart
                            xAxis={{categories}}
                            yAxis={{
                                title: {
                                    text: '',
                                },
                            }}
                            legend={{
                                enabled: showLegend
                            }}
                            plotOptions= {{
                                pie: {
                                    allowPointSelect: true,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: showLegend,
                                    },
                                    //showInLegend: true
                                }
                            }}
                            series={series}
                            onExport={this.handleExport}
                        />
                    </div>
                </Spin>
                <div className="footer">
                { toType &&<a className="more" onClick={() => handleExpand(toType,params)}>MORE</a>}
                </div>
            </div>
        );
    }
}

export default PieChartBox;


// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/components/PieChartBox.js